import './App.css';
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Header from './components/Header';
import Home from './components/Home';
import Coin from './components/Coin';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(()=>({
  App: {
    backgroundColor: "#14161a",
    minHeight: "100vh",
    color: '#fff'
  }
}));

function App() {
  const classes = useStyles();
  return (
    <BrowserRouter>
    <div className={classes.App}>
      <Header/>
      <Routes>
        <Route exact path="/" element={<Home/>}/>
        <Route exact path="/coin/:id" element={<Coin/>}/>        
      </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
